<template>
  <div>
    <main-header
      :title="title"
      :points="allPoints"
      iconLeftBtn="el-icon-back"
      @onClickLeftBtn="onClickLeftBtn"
    >
      <div class="crm-points-history d-flex justify-center align-center">
        <p class="title-text points-text">
          <img class="mr-2" :src="require(`@/assets/svg/point-unit.svg?inline`)" width="32" height="32" />
          {{ numberWithCommas(allPoints) }}
          <span class="points-text-word">{{ $t('register.point') }}</span>
        </p>
      </div>
      <div v-if="remainingExpirePoint" class="crm-points-history expired-points-text-word">
        <div>
          {{ $t('history.point-expire') }} {{ moment(remainingExpirePoint.datetime).format('DD/MM/YYYY') }}
        </div>
        <div style="margin-left: auto;" class="d-flex">
          <img class="mr-3" :src="require(`@/assets/svg/point-unit.svg?inline`)" width="20" height="20" />
          {{ numberWithCommas(remainingExpirePoint.point) }} {{ $t('register.point') }}
        </div>
      </div>
      <el-tabs class="crm-drawer-entry-history" v-model="activeNameTab">
        <el-tab-pane
          :label="$t('history.all')"
          :name="$t('history.all')"
          v-loading="isLoadingHistory"
        >
          <div v-if="allHistory.length > 0" class="item-list">
            <history-item
              v-for="(item, name, index) in allHistory"
              :name="item.typeName"
              :points="item.points"
              :time="item.date"
              :key="`${name}${index}`"
            />
          </div>
          <nothing-to-see-here
            v-else-if="!(isLoadingHistory || isErrorLoadHistory)"
            :mainText="$t('history.no-transaction-history')"
            :subText="$t('history.no-made-transaction-history')"
            useImg="fridge.png"
          />
          <nothing-to-see-here
            v-else-if="isErrorLoadHistory"
            :mainText="$t('history.sorry')"
            :subText="$t('history.unable-retrieve')"
            useImg="fridge.png"
            :haveReloadBtn="true"
            @click-reload="loadDataHistoryList"
          />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('history.points-earned')"
          :name="$t('history.points-earned')"
          v-loading="isLoadingHistory"
        >
          <div v-if="earnHistory.length > 0" class="item-list">
            <history-item
              v-for="(item, name, index) in earnHistory"
              :name="item.typeName"
              :points="item.points"
              :time="item.date"
              :key="`${name}${index}`"
            />
          </div>
          <nothing-to-see-here
            v-else-if="!(isLoadingHistory || isErrorLoadHistory)"
            :mainText="$t('history.no-transaction-history')"
            :subText="$t('history.no-made-transaction-history')"
            useImg="fridge.png"
          />
          <nothing-to-see-here
            v-else-if="isErrorLoadHistory"
            :mainText="$t('history.sorry')"
            :subText="$t('history.unable-retrieve')"
            useImg="fridge.png"
            :haveReloadBtn="true"
            @click-reload="loadDataHistoryList"
          />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('history.spent-points')"
          :name="$t('history.spent-points')"
          v-loading="isLoadingHistory"
        >
          <div v-if="burnHistory.length > 0" class="item-list">
            <history-item
              v-for="(item, name, index) in burnHistory"
              :name="item.typeName"
              :points="item.points"
              :time="item.date"
              :key="`${name}${index}`"
            />
          </div>
          <nothing-to-see-here
            v-else-if="!(isLoadingHistory || isErrorLoadHistory)"
            :mainText="$t('history.no-transaction-history')"
            :subText="$t('history.no-made-transaction-history')"
            useImg="fridge.png"
          />
          <nothing-to-see-here
            v-else-if="isErrorLoadHistory"
            :mainText="$t('history.sorry')"
            :subText="$t('history.unable-retrieve')"
            useImg="fridge.png"
            :haveReloadBtn="true"
            @click-reload="loadDataHistoryList"
          />
        </el-tab-pane>
      </el-tabs>
    </main-header>
    <main-footer />
  </div>
</template>

<script>
import MainFooter from "@components/MainFooter";
import MainHeader from "@components/MainHeader";
import HistoryItem from "@/components/history/HistoryItem.vue";
import NothingToSeeHere from "@/components/NothingToSeeHere.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import mixins from "@/helper/mixins";
import moment from "moment";
import GATracking from "@/helper/GATrackingMixins";

export default {
  mixins: [mixins, GATracking],
  components: {
    MainFooter,
    MainHeader,
    HistoryItem,
    NothingToSeeHere,
  },
  data() {
    return {
      moment,
      title: this.$t('history.point-mine'),
      activeNameTab: null,
      temp: 0,
      isLoadingHistory: false,
      isErrorLoadHistory: false,
      tabsData: [
        {
          name: this.$t('history.all'),
          adjustType: "all",
          itemList: [],
        },
        {
          name: this.$t('history.points-earned'),
          adjustType: 1,
          itemList: [],
        },
        {
          name: this.$t('history.spent-points'),
          adjustType: 3,
          itemList: [],
        },
      ],
    };
  },
  mounted() {
    this.viewActivity('CRM Point History', 'CRMPointHistory', 'viewMyPointHistory')
    this.activeNameTab = this.$t('history.all');
    this.loadDataHistoryList();
  },
  methods: {
    ...mapActions({
      fetchHistoryList: "history/fetchHistoryList",
    }),
    ...mapMutations({
      setHistory: "history/SET_HISTORY_LIST",
    }),
    loadDataHistoryList() {
      this.isLoadingHistory = true;
      this.isErrorLoadHistory = false;
      this.fetchHistoryList()
        .then(() => {
          this.isErrorLoadHistory = false;
        })
        .catch((error) => {
          this.setHistory([]);
          this.isErrorLoadHistory = error;
        })
        .finally(() => {
          this.isLoadingHistory = false;
        });
    },
    onClickLeftBtn() {
      this.trackActivity(16, 'CRMPointHistory');
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters({
      allHistory: "history/allHistoryList",
      earnHistory: "history/earnHistoryList",
      burnHistory: "history/burnHistoryList",
      remainingExpirePoint: "history/remainingExpirePoint",
      userInfo: "user/userInfo",
    }),
    allPoints() {
      return this.userInfo.point;
    },
  },
  watch: {
    activeNameTab(val) {
      switch (val) {
        case this.$t('history.all'):
          this.trackActivity(13, 'CRMPointHistory');
          break;
        case this.$t('history.points-earned'):
          this.trackActivity(14, 'CRMPointHistory');
          break;
        case this.$t('history.spent-points'):
          this.trackActivity(15, 'CRMPointHistory');
          break;
      }
    }
  }
};
</script>

<style>
:scope {
  --drawer-entry-top: 22vh;
  --tabs__content-height: calc(var(--full-content-height) - 109px);
}

.crm-points-history {
  width: 100%;
}

.crm-drawer-entry-history {
  width: 100%;
  max-width: var(--max-width-app);
  min-height: var(--tabs__content-height);
  background: #ffffff;
  box-shadow: 0px -4px 32px rgba(0, 0, 0, 0.12);
  border-radius: 16px 16px 0px 0px;
}

.item-list {
  position: relative;
  overflow: auto;
  height: inherit;
  max-height: var(--tabs__content-height);
  padding-inline: 24px;
}
.item:first-child {
  padding-top: 24px;
}
.item:last-child {
  padding-bottom: calc(24px + 48px);
}

.el-tabs__item {
  width: calc(100% / 3);
}

.title-text {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 500;
  font-size: 24px;
  line-height: 16px;
  color: #ffffff;
  text-align: center;
  width: 100%;
}
.points-text {
  font-weight: 700;
  font-size: 64px;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0em;
}
.points-text-word {
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0em;
}

.expired-points-text-word {
  width: inherit;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 16px;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0em;
}
</style>